import { render, staticRenderFns } from "./EditThoughtDialog.vue?vue&type=template&id=65e3f9ca&"
import script from "./EditThoughtDialog.vue?vue&type=script&lang=js&"
export * from "./EditThoughtDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports